var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDayzeLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 101,
    viewBox: "0 0 392 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.828 0V27.4742C145.157 23.2474 139.707 20.6891 132.254 20.6891C117.683 20.6891 105.67 33.4807 105.67 50.0542C105.67 66.6277 117.683 79.4193 132.254 79.4193C139.707 79.4193 145.157 76.861 148.828 72.6342V77.8621H165.513V0H148.828ZM135.591 63.6244C127.916 63.6244 122.355 58.3965 122.355 50.0542C122.355 41.7118 127.916 36.4839 135.591 36.4839C143.266 36.4839 148.828 41.7118 148.828 50.0542C148.828 58.3965 143.266 63.6244 135.591 63.6244Z",
    fill: "url(#paint0_linear_5_310)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.681 22.2463V27.4742C210.01 23.2474 204.56 20.6891 197.107 20.6891C182.536 20.6891 170.523 33.4807 170.523 50.0542C170.523 66.6277 182.536 79.4193 197.107 79.4193C204.56 79.4193 210.01 76.861 213.681 72.6342V77.8621H230.366V22.2463H213.681ZM200.444 63.6244C192.769 63.6244 187.208 58.3965 187.208 50.0542C187.208 41.7118 192.769 36.4839 200.444 36.4839C208.119 36.4839 213.681 41.7118 213.681 50.0542C213.681 58.3965 208.119 63.6244 200.444 63.6244Z",
    fill: "url(#paint1_linear_5_310)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.195 22.2463L262.739 56.2831L250.393 22.2463H232.039L254.174 75.3037C251.727 82.0888 248.057 84.5359 240.271 84.5359V100.108C255.843 100.887 265.743 93.8794 271.971 76.1936L290.992 22.2463H273.195Z",
    fill: "url(#paint2_linear_5_310)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M312.294 62.2896L333.317 33.3695V22.2463H291.049V37.8187H310.959L289.936 66.7389V77.8621H334.429V62.2896H312.294Z",
    fill: "url(#paint3_linear_5_310)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M351.485 56.7281H390.972C391.417 54.6147 391.639 52.39 391.639 50.0542C391.639 33.2582 379.626 20.6891 363.386 20.6891C345.812 20.6891 333.799 33.4807 333.799 50.0542C333.799 66.6277 345.589 79.4193 364.61 79.4193C375.177 79.4193 383.408 75.5262 388.858 67.9625L375.511 60.2875C373.286 62.7346 369.393 64.5143 364.832 64.5143C358.715 64.5143 353.598 62.5121 351.485 56.7281ZM351.151 44.2701C352.708 38.5973 356.935 35.4829 363.275 35.4829C368.281 35.4829 373.286 37.8187 375.066 44.2701H351.151Z",
    fill: "url(#paint4_linear_5_310)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3172 82.3102C44.3172 61.2671 62.3237 44.2082 84.5359 44.2082V2.22356C37.848 2.22356 0 38.0796 0 82.3102H44.3172Z",
    fill: "url(#paint5_linear_5_310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_310",
    x1: 42.268,
    y1: 2.22363,
    x2: 42.268,
    y2: 82.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_310",
    x1: 42.268,
    y1: 2.22363,
    x2: 42.268,
    y2: 82.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_310",
    x1: 42.268,
    y1: 2.22363,
    x2: 42.268,
    y2: 82.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_310",
    x1: 42.268,
    y1: 2.22363,
    x2: 42.268,
    y2: 82.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_310",
    x1: 42.268,
    y1: 2.22363,
    x2: 42.268,
    y2: 82.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_310",
    x1: 42.268,
    y1: 2.22363,
    x2: 42.268,
    y2: 82.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayzeLogoFull);
export default __webpack_public_path__ + "static/media/dayze-logo-full.e6f05dde1cbbbe1b0932f4d5575495da.svg";
export { ForwardRef as ReactComponent };